import React, { Component } from 'react';
import { formatMoney } from 'helpers/Formatter';
import { localize } from 'react-localize-redux';

const defaultPaymentTypes = [
  'Monthly Rent',
  'Late Fee',
  'Deposit',
  'NSF Fee',
  'Application Fee',
  'Key Deposit',
  'Amenity Fee',
  'Service Fee',
  'Ancillary Charge',
  'Deposit Increase',
];

export default localize()(
  class RentBreakdown extends Component {
    _renderPaymentType = paymentType => {
      if (defaultPaymentTypes.includes(paymentType)) {
        return this.props.translate(`${paymentType}`).props.children;
      } else {
        return paymentType;
      }
    };

    render() {
      if (!Array.isArray(this.props.paymentDetails) || this.props.paymentDetails.length === 0) {
        return null;
      }

      const style = {
        bold_padding: {
          padding: '0px 5px',
          fontWeight: '800',
        },
        padding_right: {
          padding: '0px 5px',
          fontWeight: '800',
        },
        right_align_p: {
          textAlign: 'right',
          marginBottom: '1px',
        },
      };
      return (
        <div>
          {this.props.paymentDetails.map((payment, index) => (
            <div key={index} className="row">
              <div className="col-xs-6" style={style.bold_padding}>
                <h4 style={{ margin: '0px' }}>
                  {payment.amount < 0
                    ? this.props.translate('discount')
                    : this._renderPaymentType(payment.payment_type)}
                  {!!payment.sub_payment_type && ` (${payment.sub_payment_type})`}
                </h4>
              </div>
              <div className="col-xs-6" style={style.padding_right}>
                <p style={style.right_align_p}> {formatMoney(payment.amount)} </p>
              </div>
            </div>
          ))}
        </div>
      );
    }
  }
);
